import axios from 'axios';
import { getEndpoint } from './endpoints';

export default {
    state: {
        trackingContractInvoices: [],
    },
    mutations: {
        setTrackingContractInvoices(state, payload) {
            const endpoint = getEndpoint('trackingContractInvoices', null, null, null, payload.contractId).get + '?controlId=' + payload.controlId;
            axios.get(endpoint).then(response => {
                state.trackingContractInvoices = response.data;
            })
                .catch(error => {
                    console.log(error);
                });
        },

        submitTrackingContractInvoices(state, payload) {
            const endpoint = getEndpoint('trackingContractInvoices', null, null, null, payload.contractId).post;
            axios.post(endpoint, payload).then(() => {
                this.commit('setTrackingContractInvoices', payload);
            })
                .catch(error => {
                    console.log('axios error: ' + error);
                });
        },
    },
    getters: {
        getTrackingContractInvoices(state) {
            return state.trackingContractInvoices;
        },
    },
};
